import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const fillRateByNoticeTimeseriesResponse = z.array(
  z.object({
    shift_date: z.string(),
    notice_category: z.string(),
    fill_rate: z.number(),
    shifts_requested: z.number(),
  })
)

export type FillRateByNoticeTimeseries = z.infer<
  typeof fillRateByNoticeTimeseriesResponse
>

export async function getFillRateByNoticeTimeseries(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/fill_rate_by_notice_timeseries', data, {
      signal,
    })
    .then((response) => response.data)
    .then(fillRateByNoticeTimeseriesResponse.parse)
}

export async function getFillRateByNoticeTimeseriesCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post(
      '/company/pulse/operations/fill_rate_by_notice_timeseries/csv',
      data,
      {
        signal,
      }
    )
    .then((response) => response.data)
}
